export const ASSETS_LIST_PAGE_SIZE = 20;

export const TRANSACTION_LIST_PAGE_SIZE = 10;

export const SAVINGS_PLANS_LIST_PAGE_SIZE = 6;

export const SAVINGS_PLANS_TRANSACTIONS_LIST_PAGE_SIZE = 10;

export const CRYPTO_TRANSFERS_ASSET_ITEMS_PER_PAGE = 20; // This is 20 due to a backend bug. We need to update the API to include a filter for fetching only assets with networkInformation.

export const REPORTS_LIST_PAGE_SIZE = 20;

export const ORDERS_PREVIEW_LIST = 3;

export const ORDERS_LIST_PAGE_SIZE = 15;

export const MAX_LIST_PAGE_SIZE = 100;

export const MAX_PLACEHOLDER_SIZE = 99;
